import Breadcrumb, { ItemType } from 'antd/es/breadcrumb/Breadcrumb';
import { useAtomValue } from 'jotai';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { globalAtom } from '../store/atom';
import { Loading } from '../components';
import Navigation from './navigation';
import { convertPathToTitle } from '../helper';

interface Props {
  children: JSX.Element;
}

const ContentLayout = ({ children }: Props) => {
  const { loggedIn } = useAtomValue(globalAtom);
  return (
    <div className="mb-[100px]">
      {loggedIn ? (
        <>
          <Navigation />
          <HeaderBreadcrumb />
          {children}
        </>
      ) : (
        <Loading />
      )}
    </div>
  );
};

const HeaderBreadcrumb = () => {
  const [items, setItems] = useState<ItemType[]>();
  const [show, setShow] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const path = window.location.pathname;
    const splitPath = path.split('/');
    const tempItems: ItemType[] = [];
    if (
      path !== '/' &&
      !splitPath.includes('my-profile') &&
      !splitPath.includes('quarterly-reviews') &&
      !splitPath.includes('feedback-notes') &&
      !splitPath.includes('my-feedback-notes')
    ) {
      setShow(true);
    } else {
      setShow(false);
    }

    splitPath?.forEach((p, index) => {
      if (p !== '') {
        if (index === 2 && splitPath.length > 3) {
          tempItems.push({
            title: convertPathToTitle(p),
            onClick: () => navigate(`/${splitPath[1]}/${p}`),
            className: 'cursor-pointer',
          });
        } else if (index === 3 && splitPath.length > 4) {
          tempItems.push({
            title: convertPathToTitle(p),
            onClick: () => navigate(-1),
            className: 'cursor-pointer',
          });
        } else {
          // if (p === "employees-for-the-quarter") {
          //   tempItems.push({
          //     title: "Employees for the Quarter",
          //     className: "normal-case",
          //   });
          // }
          //else
          tempItems.push({ title: convertPathToTitle(p) });
        }
      }
    });
    setItems(tempItems);
  }, [window.location.pathname]);

  return (
    <div className="p-[10px]">
      {show ? (
        <Breadcrumb items={items} className="capitalize text-[14px]" />
      ) : null}
    </div>
  );
};

export default ContentLayout;
